<template>
  <div>Redirecting...</div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "OidcSilent",
  methods: {
    ...mapActions("brain/auth", ["oidcSigninSilentCallback"]),
  },
  mounted() {
    // oidc-client-ts does NOT like our #, so we get rid of it before parsing
    let newLocation = window.location.href.split("#")[1];
    window.history.replaceState({}, null, newLocation);

    this.oidcSigninSilentCallback().catch((e) => {
      console.log("siginSilentCallback error:", e);
    });
  },
};
</script>
